import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EmployeeService } from '../employee.service';
import { RBACService } from '../../shared/rbac.service';
import { UtilsService } from '../../shared/utils.service';

@Component({
  selector: 'app-employees-sites-visited',
  templateUrl: './employees-sites-visited.component.html',
  styleUrls: ['./employees-sites-visited.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EmployeesSitesVisitedComponent implements OnInit {
  // RBAC permission flag: resolved once in ngOnInit().
  canView: boolean = false;

  constructor(
    public employeeService: EmployeeService,
    public rbac: RBACService,
    public utils: UtilsService
  ) {}

  ngOnInit() {
    // Resolve RBAC permission flag.
    this.canView = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_EMPLOYEES_SITE_ASSOCIATIONS,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    // Redirect if user lacks view permission.
    if (!this.canView) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to view sites visited.'
      );
      this.utils.redirectByLastSegment('details');
      return;
    }
  }

  protected readonly RBACService = RBACService;
}
